var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"pulse-spinner",style:([_vm.wrapperStyle]),attrs:{"fx":"","fxacenter":""}},_vm._l((_vm.nbBalls),function(n){return _c('div',{key:n,staticClass:"v-pulse",style:([_vm.spinnerStyle, _vm.spinnerDelay(n)])})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }